module.exports = __webpack_public_path__ + "static/img/20200629070900_38924.0c31068.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20200629070900_38924.png
// module id = uqhc
// module chunks = 73